import $http from '../../axios';
import {Notification, MessageBox} from 'element-ui';
import {
	defaultModalDocumentThreadHistory,
	defaultModalPaymentMethods,
	defaultNewContact,
	defaultSelectedDocument,
	defaultSelectedDocumentProduct,
	defaultSelectedModel, defaultsubscriberId, defaultTableSearchGlobal
} from '../inventory-movements/state';
import {emitToparent} from './mutations';

export async function getPaymentMethods({commit, state}) {
	await $http
		.get(`/api/get-formas-pago`)
		.then(response => {
			commit('setPaymentMethods', response.data.data);
		})
		.catch(error => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 2000,
				customClass: 'notification-box'
			});
		});
}

export async function fetDocumentPaymentMethods({commit, state,dispatch}, data) {
		return new Promise(async (resolve, reject) => {

		let data_json = {
			'document_id': state.selected_document.id,
			from_inventory_documents:state.from_inventory_documents,
			paymentMethods: data
		};

		await $http
			.post('/api/documento/guardar-formas-de-pago/', data_json)
			.then(async response => {
              /*  await dispatch('accountingDoc', state.selected_document.id)*/
                commit('setCompleteProcess', true);
                Notification.success({
                    title: 'Exito!',
                    message: 'Metodos de pago guardados',
                    type: 'success',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                resolve();
            })
			.catch(error => {
				Notification.error({
					title: 'Error!',
					message: error.response.data.message,
					type: 'error',
					duration: 2000,
					customClass: 'notification-box'
				});
				reject(error)
			});
	});
}

/**
 * Contabilizar documento
 */
export async function postFormsOfPayment({state}) {
	await $http
		.get('/api/documento/contabilizar/' + state.selected_document.id)
		.then(response => {
            Notification.success({
                title: 'Exito!',
                message: 'Metodos de pago guardados',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
		})
		.catch(error => {
            console.log(error.response.data)
			Notification.error({
				title: 'Error!',
                message: error.response.data.message,
				type: 'error',
				duration: 2000,
				customClass: 'notification-box'
			});
		});
}


export async function fetchModel({commit, state, rootState}, model_id) {
	let params = {
		params: {
			branchoffice_id: localStorage.selected_branchoffice
		}
	};

	if (!state.selected_model) {
		await $http
			.get('/api/obtener-modelo/' + model_id, params)
			.then(response => {
				commit('setSelectedModel', response.data.data);
			})
			.catch(error => {
				Notification.error({
					title: '¡Error!',
					message: error.message,
					type: 'error',
					duration: 1500,
					customClass: 'notification-box'
				});
			});
	} else {
		commit('setSelectedModel', state.selected_model);
	}
}

export async function fetchDocument({commit, state}, {document_id, model_id}) {

	let params = {
		model_id
	};

	await $http.get('/api/documento-por-id/' + document_id, {params})
		.then(async response => {
			commit('setSelectedDocument', response.data.data);
		}).catch((error) => {
			console.error(error);
		});
}

export async function getBalance({commit, state}, params) {
	await $http.get('/api/saldo-por-tercero', {params})
		.then(async response => {
			commit('setBalance', response.data.data);
		}).catch((error) => {
			console.error(error);
		});
}

export async function accountingDoc({commit, state, dispatch}, document_id){
    await $http.get(`/api/documento/contabilizar/${document_id}`)
        .then(response => {
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 4500,
                customClass: "notification-box"
            });
        });
}

export async function reAccountingDoc({commit, state, dispatch}, document_id){
    await $http.post(`/api/documento/recontabilizar/${document_id}`)
        .then(response => {
            console.log(response);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 4500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/payments-methods-modal/actions.js